import React from 'react';
import Modal from '../Modal/Modal';
import { Heading } from '../Heading/Heading';
import { FormattedMessage } from 'react-intl';
import NamedLink from '../NamedLink/NamedLink';
import { userHasProfileData } from '../../util/userHelpers';

const ModalMissingProfileInfo = props => {
  const { onManageDisableScrolling, currentUser } = props;
  const hasFilledDetails = userHasProfileData(currentUser);

  return (
    <Modal
      id="fillInDetailFirstModal"
      isOpen={!hasFilledDetails}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
      noCloseButton
    >
      <Heading as="h2">
        <FormattedMessage id="EditListingWizard.fillInProfileHeading" />
      </Heading>
      <p>
        <FormattedMessage
          id="EditListingWizard.fillInProfileDesc"
          values={{
            lineBreak: <br />,
            link: text => <NamedLink name="ProfileSettingsPage">{text}</NamedLink>,
          }}
        />
      </p>
    </Modal>
  );
};

export default ModalMissingProfileInfo;
